import Layout from '@layout/Index'

export const userBankAccount = [
  {
    path: '/user-bank-account',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "user-bank-account-table" */ './pages/UserAccountTable.vue'),
        name: '员工账户列表',
        meta: {
          title: '员工账户列表',
        },
      },
      {
        path: 'create/batch',
        component: () => import(/* webpackChunkName: "user-bank-account-batch" */ './pages/UserBankBatchForm.vue'),
        name: '批量添加员工账户',
        meta: {
          type: 'create',
          title: '批量添加员工账户',
        },
      },
      {
        path: 'edit/batch',
        component: () => import(/* webpackChunkName: "user-bank-account-batch" */ './pages/UserBankBatchForm.vue'),
        name: '批量修改员工账户',
        meta: {
          type: 'edit',
          title: '批量修改员工账户',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-bank-account/user-bank-account.route.js